import { css } from 'styled-components';
// to style UiMarkdown and UiTextBlock consistently
export function getTextSizeCSS(textSize) {
    return (textSize &&
        (textSize === 'Large'
            ? css `
          font-size: 1.5rem;
          line-height: 1.75;
        `
            : css `
          font-size: 1rem;
        `));
}
//# sourceMappingURL=textSize.js.map